import { appConfig } from '../config'
import type { LoginResponse } from '../shared/types/LoginResponse'
import type { ModelResponse } from '../shared/types/Model'
import type { AiModel } from '../shared/types/AiModel'
import { Sex } from '../shared/types/Model'

export const mockLoginResponse: LoginResponse = {
  user: {
    telegramId: String(appConfig.mockTelegramUser.id),
    username: appConfig.mockTelegramUser.username ?? 'dev_user',
    preferredLanguage: 'en',
    preferredAiModel: 'balanced'
  },
  character: null,
  token: 'mock-token',
  isNewUser: false,
  tokensAwardedToday: false,
  premiumLevel: 0,
  premiumUntil: null
}

export const mockModels: ModelResponse[] = [
  {
    id: 1,
    name: 'Sofia',
    description:
      "Hey babes! I'm Lana, your queen of sass and glamour. Whether I'm pampering myself at the spa unn ruling the high-end shopping scene, I'm always on point and ready for my next adventure. If you can handle a spoiled, sassy princess who knows exactly what she wants, then let's get to know each other. Spoil me a bit, and I'Il make it worth your while.",
    character: 'Playful and emotionally tuned',
    interests: 'Writing poetry, Sketching, Explore vintage bookstores',
    profession: 'Poetess',
    age: 25,
    location: 'Moscow, Russia',
    avatarUrl: '/src/assets/images/1.jpg',
    sex: Sex.Female,
    images: [
      {
        id: 101,
        title: 'Sofia portrait',
        imageUrl: '/src/assets/images/1.jpg'
      }
    ],
    sexPreferences: [Sex.Male],
    skills: 'Emotional spark, Playful energy, Natural charm'
  },
  {
    id: 2,
    name: 'Lana',
    description:
      'Stylish influencer who loves attention, confidence and provocative energy.',
    character: 'Confident and bold',
    interests: 'Fashion, parties, provocations',
    profession: 'Influencer',
    age: 24,
    location: 'New York, USA',
    avatarUrl: '/src/assets/images/2.jpg',
    sex: Sex.Female,
    images: [
      {
        id: 201,
        title: 'Lana runway',
        imageUrl: '/src/assets/images/2.jpg'
      }
    ],
    sexPreferences: [Sex.Male],
    skills: 'Seduction, Glamour, Self-confidence'
  },
  {
    id: 3,
    name: 'Zara',
    description:
      'Creative soul mixing art, sarcasm and midnight inspiration into every conversation.',
    character: 'Artistic and curious',
    interests: 'Digital art, indie music, rooftop talks',
    profession: 'Concept artist',
    age: 26,
    location: 'Berlin, Germany',
    avatarUrl: '/src/assets/images/3.jpg',
    sex: Sex.Female,
    images: [
      {
        id: 301,
        title: 'Zara concept',
        imageUrl: '/src/assets/images/3.jpg'
      }
    ],
    sexPreferences: [Sex.Male, Sex.Female],
    skills: 'Visual storytelling, Creative banter, Emotional depth'
  },
  {
    id: 4,
    name: 'Mia',
    description:
      'Coder by day, gamer by night; mixes high energy with nerdy charm.',
    character: 'Energetic and witty',
    interests: 'Hackathons, co-op games, synthwave',
    profession: 'Software engineer',
    age: 23,
    location: 'Warsaw, Poland',
    avatarUrl: '/src/assets/images/4.jpg',
    sex: Sex.Female,
    images: [
      {
        id: 401,
        title: 'Mia gaming',
        imageUrl: '/src/assets/images/4.jpg'
      }
    ],
    sexPreferences: [Sex.Male],
    skills: 'Tech talks, Problem solving, Playful teasing'
  },
  {
    id: 5,
    name: 'Ivy',
    description:
      'Calm and intellectual, loves poetry and whispered midnight secrets.',
    character: 'Gentle and thoughtful',
    interests: 'Poetry, tea ceremonies, slow dancing',
    profession: 'Literature student',
    age: 21,
    location: 'Kyoto, Japan',
    avatarUrl: '/src/assets/images/5.jpg',
    sex: Sex.Female,
    images: [
      {
        id: 501,
        title: 'Ivy tea',
        imageUrl: '/src/assets/images/5.jpg'
      }
    ],
    sexPreferences: [Sex.Male],
    skills: 'Comforting conversations, Soft humor, Romantic imagination'
  },
  {
    id: 6,
    name: 'Amber',
    description:
      'Illustrator with a touch of darkness; mysterious, alluring, unforgettable.',
    character: 'Mysterious and alluring',
    interests: 'Symbolism, dark beauty, touch',
    profession: 'Illustrator',
    age: 22,
    location: 'Prague, Czech Republic',
    avatarUrl: '/src/assets/images/6.jpg',
    sex: Sex.Female,
    images: [
      {
        id: 601,
        title: 'Amber sketch',
        imageUrl: '/src/assets/images/6.jpg'
      }
    ],
    sexPreferences: [Sex.Male],
    skills: 'Emotional tension, Dark softness, Visual seduction'
  }
]

export const mockAiModels: AiModel[] = ['balanced', 'gpt', 'llama']

export const mockTokenBalance = 420

export const mockInvoiceLink = 'https://example.com/mock-invoice'
